import { DOCUMENT } from '@angular/common';
import { Component, OnInit, Renderer2, Input, Inject } from '@angular/core';

@Component({
    selector: 'finder-script-loader',
    template: ''
})
export class ScriptLoaderComponent implements OnInit {
    @Input() src: string;

    constructor(
        private renderer: Renderer2,
        @Inject(DOCUMENT) private document: Document,
    ) { }

    ngOnInit() {
        if (this.src) {
            this.loadScript(this.src);
        }
    }

    loadScript(src: string): void {
        const script = this.renderer.createElement('script');
        script.type = 'text/javascript';
        script.src = src;
        this.renderer.appendChild(this.document.head, script);
    }

}
